'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _button = require('@alicd/next/lib/button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _tag = require('@alicd/next/lib/tag');

var _tag2 = _interopRequireDefault(_tag);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require('@alicd/next/lib/grid');

var _grid2 = _interopRequireDefault(_grid);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;

var TagSelect = function (_React$Component) {
  (0, _inherits3.default)(TagSelect, _React$Component);

  function TagSelect(props) {
    (0, _classCallCheck3.default)(this, TagSelect);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TagSelect.__proto__ || (0, _getPrototypeOf2.default)(TagSelect)).call(this, props));

    _this2.dataSource = [];
    _this2.timer = 0;
    _this2.tags = [];
    _this2._tags_obj = {};

    var selectedUnlimited = true;
    var value = _this2.normalizeValue(typeof props.value != "undefined" ? props.value : props.defaultValue, props);
    if (_this2.props.defaultValue || _this2.props.value) {
      selectedUnlimited = false;
    }
    _this2.state = {
      maxTagsAutoShow: 0,
      _val: value,
      spread: _this2.props.autoSpread,
      selectedUnlimited: selectedUnlimited
    };
    _this2.dataSource = JSON.parse((0, _stringify2.default)(props.dataSource));
    _this2.adjustSprid = _this2.adjustSprid.bind(_this2);
    return _this2;
  }

  (0, _createClass3.default)(TagSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = this;
      this._hasTags = true;
      if (this.props.showSpread) {
        this.adjustSprid();
        window.addEventListener('resize', this.adjustSprid);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this = this;
      if (this.props.showSpread) {
        window.removeEventListener('resize', this.adjustSprid);
      }
    }
  }, {
    key: 'normalizeValue',
    value: function normalizeValue(value) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

      if (typeof value == "undefined") {
        return props.multiple ? [] : null;
      }
      return value;
    }
  }, {
    key: 'adjustSprid',
    value: function adjustSprid() {
      var contentWidth = this.content;
      var tagsWidth = 0;
      var maxTagsAutoShow = 0;

      if (this.tags.length == this.dataSource.length) {
        this.tags.map(function (item, i) {
          tagsWidth += item;
          if (tagsWidth > contentWidth && maxTagsAutoShow === 0) {
            maxTagsAutoShow = i;
          }
        });
      } else {
        tagsWidth = contentWidth + 1;
        maxTagsAutoShow = this.state.maxTagsAutoShow;
      }

      if (tagsWidth <= contentWidth) {
        this.setState({
          maxTagsAutoShow: 0
        });
        return false;
      }
      if (maxTagsAutoShow > 0) {
        this.setState({
          maxTagsAutoShow: maxTagsAutoShow
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (next.dataSource !== this.props.dataSource) {
        this._hasTags = false;
        this._tags_obj = {};
        this.tags = [];
        this.dataSource = JSON.parse((0, _stringify2.default)(next.dataSource));
        if (this.props.showSpread) {
          clearTimeout(this.timer);
          this.timer = setTimeout(this.adjustSprid.bind(this), 20);
        } else {
          this.setState(this.state);
        }
      }
      if (typeof next.value != "undefined") {
        this.setState({ _val: this.normalizeValue(next.value, next) });
      }
    }
  }, {
    key: 'onChangeUnlimited',
    value: function onChangeUnlimited(e) {
      if (this.props.multiple !== false ? this.state._val.length > 0 : typeof this.state._val != "undefined") {
        this.setState({
          _val: this.props.multiple !== false ? [] : null
        });
        this.props.onChange(this.props.multiple !== false ? [] : null);
      }
    }
  }, {
    key: 'onChangeTag',
    value: function onChangeTag(e, record) {

      if (record) {
        record.selected = e;
      }
      var val = void 0;
      if (this.props.multiple !== false) {
        val = [];
        this.dataSource.map(function (item) {
          item.selected === true && val.push(item.value);
        });
        this.setState({
          _val: val
        });
      } else {
        this.dataSource.map(function (item) {
          if (record.value === item.value) {
            record.selected = e;
          } else {
            record.selected = false;
          }
        });
        val = !e ? null : typeof record.value == "undefined" ? null : record.value;
        this.setState({
          _val: val
        });
      }
      this.props.onChange(val);
    }
  }, {
    key: 'processData',
    value: function processData(val, data) {
      if (val) {
        data.map(function (item) {
          if (val.indexOf(item.value) > -1) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
      }
    }
  }, {
    key: 'clickToChangeSpread',
    value: function clickToChangeSpread(e) {
      this.setState({
        spread: !this.state.spread
      });
    }
  }, {
    key: '_contentRefHandler',
    value: function _contentRefHandler(ref) {
      if (ref) {
        this.content = ref.offsetWidth;
      }
    }
  }, {
    key: '_tagRefHandler',
    value: function _tagRefHandler(ref, index) {
      if (!this._hasTags && ref) {
        if (!this._tags_obj[ref.innerText + '__' + index]) {
          this._tags_obj[ref.innerText + '__' + index] = ref.offsetWidth;
          this.tags.push(ref.offsetWidth);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          locale = _props.locale,
          value = _props.value,
          a = _props.dataSource,
          showSpread = _props.showSpread,
          multiple = _props.multiple,
          selectedKeys = _props.selectedKeys,
          showUnlimited = _props.showUnlimited,
          language = _props.language,
          autoSpread = _props.autoSpread,
          others = (0, _objectWithoutProperties3.default)(_props, ['locale', 'value', 'dataSource', 'showSpread', 'multiple', 'selectedKeys', 'showUnlimited', 'language', 'autoSpread']);


      var dataSource = this.dataSource;

      var val = this.state._val;

      // if(!value){
      //   if(multiple !== true) {
      //     val = (typeof value == "undefined") ? null : value;
      //   } else {
      //     val = [];
      //   }
      // } else {
      //   val = value;
      // }

      if (Object.prototype.toString.call(val) !== '[object Array]' && multiple !== false) {
        console.error('The value of TagSelect must be array when multiple');
        return null;
      }

      if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && multiple === false) {
        console.error('The value of TagSelect should not be array when multiple equal to false');
        return null;
      }

      if (multiple !== false) {
        this.processData(val, dataSource);
        if (val.length === 0) {
          this.state.selectedUnlimited = true;
        } else {
          this.state.selectedUnlimited = false;
        }
      } else {
        if (!val && val !== 0) {
          this.state.selectedUnlimited = true;
        } else {
          this.state.selectedUnlimited = false;
        }
      }

      if (others && others.className) {
        others.className = 'tag-select ' + others.className;
      } else {
        others.className = 'tag-select';
      }

      var maxTagsAutoShow = this.state.maxTagsAutoShow;
      var tagsArr = dataSource;
      if (maxTagsAutoShow > 0 && !this.state.spread) {
        tagsArr = dataSource.slice(0, maxTagsAutoShow);
      }

      return _react2.default.createElement(
        Row,
        (0, _extends3.default)({ type: 'no-padding' }, others),
        showUnlimited ? _react2.default.createElement(
          Col,
          { fixedSpan: 4 },
          _react2.default.createElement(
            _tag2.default,
            { animation: false, onChange: function onChange(e) {
                _this3.onChangeUnlimited.call(_this3, e, null);
              }, className: 'unlimited-btn', selected: this.state.selectedUnlimited, size: this.props.size, shape: 'selectable', type: 'primary' },
            locale.cancel
          )
        ) : null,
        _react2.default.createElement(
          Col,
          null,
          _react2.default.createElement(
            'div',
            { ref: this._contentRefHandler.bind(this) },
            multiple !== false ? tagsArr.map(function (item, index) {
              return _react2.default.createElement(
                'span',
                { ref: function ref(_ref) {
                    _this3._tagRefHandler.call(_this3, _ref, index);
                  }, key: 'span_' + index },
                _react2.default.createElement(
                  _tag2.default,
                  { animation: false, key: item.value, onChange: function onChange(e) {
                      _this3.onChangeTag.call(_this3, e, item);
                    }, className: 'tag-btn', selected: item.selected ? true : false, size: _this3.props.size, shape: 'selectable', type: 'normal' },
                  item.text
                )
              );
            }) : tagsArr.map(function (item, index) {
              return _react2.default.createElement(
                'span',
                { ref: function ref(_ref2) {
                    _this3._tagRefHandler.call(_this3, _ref2, index);
                  }, key: 'span_' + index },
                _react2.default.createElement(
                  _tag2.default,
                  { animation: false, key: item.value.toString(), onChange: function onChange(e) {
                      _this3.onChangeTag.call(_this3, e, item);
                    }, className: 'tag-btn', selected: val === item.value, size: _this3.props.size, shape: 'selectable', type: 'normal' },
                  item.text
                )
              );
            })
          )
        ),
        showSpread === false ? null : _react2.default.createElement(
          Col,
          { fixedSpan: 3, className: 'spread-btn' },
          this.state.maxTagsAutoShow !== 0 ? _react2.default.createElement(
            _button2.default,
            { shape: 'text', style: { marginTop: 8 }, onClick: this.clickToChangeSpread.bind(this), className: 'spread-text' },
            this.state.spread ? locale.pickUp : locale.spread,
            _react2.default.createElement(_icon2.default, { className: this.state.spread ? 'spread-icon' : 'pick-up-icon', type: 'arrow-down' })
          ) : null
        )
      );
    }
  }]);
  return TagSelect;
}(_react2.default.Component);

TagSelect.propTypes = {
  multiple: _propTypes2.default.bool,
  autoSpread: _propTypes2.default.bool,
  dataSource: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  showUnlimited: _propTypes2.default.bool,
  showSpread: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['large', 'medium', 'small']),
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool, _propTypes2.default.array]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool, _propTypes2.default.array])
};
TagSelect.defaultProps = {
  multiple: false,
  dataSource: null,
  selectedKeys: null,
  autoSpread: false,
  size: 'medium',
  showUnlimited: true,
  showSpread: true,
  onChange: function onChange() {}
};


var LocaleMyComponent = (0, _localeProvider2.default)(TagSelect);
LocaleMyComponent.LOCALE = {
  'en-us': {
    cancel: 'unlimited',
    spread: 'spread',
    pickUp: 'pack up'
  },
  'zh-cn': {
    cancel: '不限',
    spread: '展开',
    pickUp: '收起'
  },
  'zh-tw': {
    cancel: '不限',
    spread: '收起',
    pickUp: '展開'
  }
};

exports.default = LocaleMyComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-tag-select@0.0.21@@alicd/crui-tag-select/lib/index.js
// module id = 282
// module chunks = 0